import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable, reaction} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {post} from '../common/requester'
import Schedule from "./Schedule";

export default class Participant extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      company_user_id: observable,
      name: observable,
      participated: observable,
      was_validated: observable,
    })
    // reaction(() => this.company_id, (new_id, old_id) => {
    //   this.get_company_sports(new_id);
    // })
  }

  company_user_id = 0;
  name = '';
  participated = false;
  was_validated = false;

  get is_valid() {
    return true;
  }

  validate = () => {
    this.was_validated = true;
    return this.is_valid;
  }
}